import ConfigurazioniPage from "./pages/ConfigurazioniPage.vue";
import ConfigurazioniMagazzinoPage from "./pages/ConfigurazioniMagazzinoPage.vue";
import ConfigurazioniContabilitaPage from "./pages/ConfigurazioniContabilitaPage.vue";
import ConfigurazioneGeneralePage from "./pages/ConfigurazioneGeneralePage.vue";
import ConfigurazioneGeneraleVociMenuListPage from "./pages/ConfigurazioneGeneraleVociMenuListPage.vue";
import ConfigurazioneGeneraleVociMenuListComponent from "./components/ConfigurazioneGeneraleVociMenuListComponent.vue";
import ConfigurazioneGeneraleVociMenuModalEditComponent from "./components/ConfigurazioneGeneraleVociMenuModalEditComponent.vue";
import ConfigurazioneGeneralePazientiMenuListComponent from "./components/ConfigurazioneGeneralePazientiMenuListComponent.vue";
import ConfigurazioneGeneralePazientiMenuListPage from "./pages/ConfigurazioneGeneralePazientiMenuListPage.vue";
import ConfigurazioneGeneralePazientiMenuModalEditComponent from "./components/ConfigurazioneGeneralePazientiMenuModalEditComponent.vue";

export default {
	ConfigurazioniPage,
	ConfigurazioniMagazzinoPage,
	ConfigurazioniContabilitaPage,
	ConfigurazioneGeneralePage,
	ConfigurazioneGeneraleVociMenuListPage,
	ConfigurazioneGeneraleVociMenuListComponent,
	ConfigurazioneGeneraleVociMenuModalEditComponent,
	ConfigurazioneGeneralePazientiMenuListComponent,
	ConfigurazioneGeneralePazientiMenuListPage,
	ConfigurazioneGeneralePazientiMenuModalEditComponent,
};
